export default (fieldName, fullErrorText) => [
  [field => field, fullErrorText || `Please complete ${fieldName}`],
]
